import * as React from 'react';
import PropTypes from 'prop-types';
import {translate} from "react-i18next";
import { TextField} from "material-ui";
import {Subbar, Title, PageHeader} from "ah-tools";
import {Button, Dropdown, Form, Grid, Icon, Segment} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {IconButton, Toggle} from "../extensions";

const defaultHouse = {
	name: '',
	link: '',
	timezone: '',
	ceo: '',
	email: '',
	postal_address: '',
	create_client: false
};

class HouseCreate extends React.Component {
	state = {
		focused: {
			name: false,
			timezone: false
		},
		toggleDetail: true
	};
	timer = null;
	house = defaultHouse;

	
	set = (name, value, delay = this.props.typingDelay) => {
		this.house = {
			...this.house,
			[name]: value
		};
		window.clearTimeout(this.timer);
		this.timer = window.setTimeout(() => {
			this.forceUpdate();
		}, delay);
	};
	
	// value = name => this.state.house[name];
	value = name => this.house[name];
	
	focused = name => this.setState(s => ({
		...s,
		focused: {
			...s.focused,
			[name]: true
		}
	}));
	
	reset = () => this.setState({house: defaultHouse});
	
	required = (name, error = 'Pflichtfeld') => this.value(name).trim() === '' && this.state.focused[name] ? error : null;
	
	isValid = () => {
		const {timezone, name, ceo, email, postal_address} = this.house;
		return timezone !== '' && name !== '' && ceo !== '' && email !== '' && postal_address !== '';
	};
	
	// save = () => this.isValid() && this.props.onCreate(this.state.house, () => this.props.afterCreate());
	save = () => this.isValid() && this.props.onCreate(this.house, ({house}) => {
		console.info('HOUSE', house);
		this.props.afterCreate(this.state.toggleDetail ? house.house_id : undefined);
		// showSnackbar('snackbar.house.created');
	});
	
	render() {
		const {timezones, isCreating, onBack, isFetchingTimezones} = this.props;
		
		return (
			<div>
				<PageHeader align="space-between">
					<Subbar>
						{onBack && <IconButton onClick={onBack}><Icon name={"chevron left"} size="large"/></IconButton>}
						<Title style={{
							marginLeft: 10
						}}>Neues Autohaus anlegen</Title>
					</Subbar>
					<Button disabled={!this.isValid()} form="house-form" positive loading={isCreating}>Anlegen</Button>
				</PageHeader>
				<Segment basic padded>
					<Form style={{padding: 20}} id="house-form" loading={isCreating} onSubmit={this.save}>
						<Grid stackable={true} container>
							<Grid.Row columns={2}>
								<Grid.Column computer={6} largeScreen={4} tablet={8}>
									<Form.Field>
										<TextField errorText={this.required('name')} hintText="Name des Hauses"
										           onBlur={this.focused.bind(this, 'name')}
										           floatingLabelText="Name des Hauses" required
										           onChange={(_, newValue) => this.set('name', newValue.trim())}/>
									</Form.Field>
									<Form.Field>
										<TextField hintText="Link des Hauses (optional)"
										           floatingLabelText="Link des Hauses (optional)"
										           onChange={(_, newValue) => this.set('link', newValue.trim())}/>
									</Form.Field>
									<Form.Field>
										<TextField hintText="CEO"
										           onBlur={this.focused.bind(this, 'ceo')}
										           required
										           errorText={this.required('ceo')}
										           floatingLabelText="CEO"
										           onChange={(_, newValue) => this.set('ceo', newValue.trim())}/>
									</Form.Field>
									<Form.Field>
										<TextField hintText="E-Mail"
										           type={'email'}
										           onBlur={this.focused.bind(this, 'email')}
										           errorText={this.required('email')}
										           floatingLabelText="E-Mail"
										           required
										           onChange={(_, newValue) => this.set('email', newValue.trim())}/>
									</Form.Field>
								</Grid.Column>
								<Grid.Column computer={6} tablet={8} largeScreen={4}>
									<Form.Field>
										<TextField hintText="Anschrift"
										           required
										           onBlur={this.focused.bind(this, 'postal_address')}
										           errorText={this.required('postal_address')}
										           type={'text'}
										           floatingLabelText="Anschrift"
										           multiLine={true}
										           onChange={(_, newValue) => this.set('postal_address', newValue.trim())}/>
									</Form.Field>
									<label htmlFor="timezones" style={{display: 'block', marginTop: 35, color: 'rgba(0,0,0,0.3)'}}>Zeitzone
										des Hauses</label>
									<Dropdown
										id="timezones"
										className={'icon ith-dropdown'}
										icon={'world'}
										labeled={true}
										floating={true}
										button={true}
										options={timezones.map(t => ({key: t, text: t, value: t}))}
										placeholder="Wähle eine Zeitzone aus"
										search={true}
										fluid={false}
										selection={true}
										allowAdditions={false}
										loading={isFetchingTimezones}
										value={this.value('timezone')}
										onChange={(_, data) => this.set('timezone', data.value, 0)}
										onBlur={this.focused.bind(this, 'timezone')}
										noResultsMessage="Keine Zeitzone gefunden"
									/>
									<Form.Field style={{marginTop: 70}}>
										<Toggle
											toggled={this.value('create_client')}
											label="Neuen internen Kunden mit dem selben Namen anlegen"
											labelPosition="right"
											onToggle={(_, value) => this.set('create_client', value, 0)}
										/>
									</Form.Field>
									<Form.Field style={{marginTop: 30}}>
										<Toggle
											toggled={this.state.toggleDetail}
											label={this.state.toggleDetail ? 'Zur Detailseite nach der Erstellung' : 'Zur Übersicht nach der Erstellung'}
											labelPosition="right"
											onToggle={(_, state) => this.setState({toggleDetail: state})}/>
									</Form.Field>
								</Grid.Column>
							</Grid.Row>
						</Grid>
						{/*<Form.Field width={3}>*/}
						
						{/*</Form.Field>*/}
					</Form>
				</Segment>
				{/*<pre>{JSON.stringify(this.state, null, 4)}</pre>*/}
				{/*<pre>{JSON.stringify(this.house, null, 4)}</pre>*/}
			</div>
		);
	}
}

HouseCreate.propTypes = {
	timezones: PropTypes.arrayOf(PropTypes.string),
	onCreate: PropTypes.func.isRequired,
	isCreating: PropTypes.bool,
	isFetchingTimezones: PropTypes.bool,
	onBack: PropTypes.func,
	afterCreate: PropTypes.func.isRequired,
	typingDelay: PropTypes.number
};

HouseCreate.defaultProps = {
	timezones: [],
	isCreating: false,
	isFetchingTimezones: false,
	typingDelay: 300
};

export default withRouter(translate()(HouseCreate));


// WEBPACK FOOTER //
// ./src/components/HouseCreate.js